module.exports = __webpack_public_path__ + "static/media/ane-ending.a9ae095a.mp3";